import React from 'react';
import PropTypes from 'prop-types';
import { WixStyleReactEnvironmentContext } from './context';
import { WixStyleReactEnvironmentProviderProps } from './WixStyleReactEnvironmentProvider.types';

/** A wrapper component for an app to hold cross library global configuration such as locale, rtl and others */
const WixStyleReactEnvironmentProvider = ({
  locale = 'en',
  pageHeaderId,
  children,
}: WixStyleReactEnvironmentProviderProps) => {
  return (
    <WixStyleReactEnvironmentContext.Provider value={{ locale, pageHeaderId }}>
      {children}
    </WixStyleReactEnvironmentContext.Provider>
  );
};

WixStyleReactEnvironmentProvider.displayName =
  'WixStyleReactEnvironmentProvider';

WixStyleReactEnvironmentProvider.propTypes = {
  locale: PropTypes.string,
  pageHeaderId: PropTypes.string,
  children: PropTypes.node,
};

export default WixStyleReactEnvironmentProvider;
